import api from "@/services/api";
import { ENDPOINTS } from "@/constants/endpoints";
import url from "@/helpers/url";

export default {
  async getTasks(coop, params, page = 1) {
    try {
      const { data } = await api.get(
        url(ENDPOINTS.tasks, { coopId: coop, page }),
        { params }
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getTask(coopId, id) {
    try {
      const { data } = await api.get(url(ENDPOINTS.taskDetail, { coopId, id }));
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getTaskCount() {
    try {
      const { data } = await api.get(ENDPOINTS.adminTaskCount);
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getAdminTasks(query) {
    try {
      const { data } = await api.get(ENDPOINTS.adminTask, { params: query });
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getAdminTask(id) {
    try {
      const { data } = await api.get(url(ENDPOINTS.adminTaskDetail, { id }));
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async sendTaskStatus(id, body) {
    try {
      const { data } = await api.put(
        url(ENDPOINTS.adminTaskAcceptance, { id }),
        body
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
